import { Trans } from 'react-i18next';
import { useSelector } from 'react-redux';

import Badge from 'components/field/Badge';
import Image from 'components/global/Image';
import Typography from 'components/global/Typography';

import useMediaQuery from 'hooks/useMediaQuery';

import { Breakpoints } from 'utils/const.styles';

import * as S from './PriceCalculator.styled';

const PackageImages = {
	FreePackage: 'https://storage.googleapis.com/tryoto-public/public/assets/icons/memberships/bronze.png',
	StarterPackage: 'https://storage.googleapis.com/tryoto-public/public/assets/icons/memberships/silver.png',
	ScalePackage: 'https://storage.googleapis.com/tryoto-public/public/assets/icons/memberships/gold.png'
};

const PackageSelection = (props) => {
	const { selectedPackage, setSelectedPackage } = props;
	const isMobile = useMediaQuery(Breakpoints.mobile);
	const currentPackage = useSelector((state) => state?.user?.planName);

	return (
		<S.PackageSelectionContainer>
			{['FreePackage', 'StarterPackage', 'ScalePackage'].map((item, index) => (
				<S.PackageButton
					key={index}
					onClick={() => setSelectedPackage(item)}
					className={selectedPackage === item ? 'selected' : ''}
					disabled={
						(currentPackage === 'StarterPackage' && item === 'FreePackage') ||
						(currentPackage === 'ScalePackage' && (item === 'StarterPackage' || item === 'FreePackage'))
					}
					variant="borderless">
					{!isMobile && <Image width={'4.5rem'} height={'4.5rem'} url={PackageImages[item]} />}
					<S.PackageButtonTextContainer>
						<S.PackageButtonTitle>
							<Typography fontWeight="500">{item}</Typography>
							{item === currentPackage && <Badge text="current" />}
						</S.PackageButtonTitle>
						{!isMobile && (
							<Typography variant="caption" color="var(--content-3)" align="left" fullWidth noWrap>
								<Trans
									i18nKey={`priceCalculator.${item}.description`}
									components={{
										blackText: <span style={{ color: 'var(--black)' }} />
									}}
								/>
							</Typography>
						)}
					</S.PackageButtonTextContainer>
				</S.PackageButton>
			))}
		</S.PackageSelectionContainer>
	);
};

export default PackageSelection;
